module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"inventory_play","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"level":{"type":"string"}},"required":["user","level"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/inventory_play.json
// module id = 549
// module chunks = 97